import { callApi } from '@local_modules/generic/fetch.js'

export async function loadGroupContacts (appAccountId) {
  const apiUrl = '/api/intercompany/:appAccountId/group-contacts'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  console.log(data)

  return data
}
